import classes from '@/components/Shares/Dropdown.module.css';
import { Button, Image, Menu, Paper } from '@mantine/core';
import { useState } from 'react';
import { serviceProviders as services } from '../serviceProviders';
export const ServicesProviderDropdown: React.FC = () => {
  const [service, setServices] = useState(services[0]);
  return <Menu shadow="md" width={400} withArrow arrowPosition="center" arrowSize={15} position="bottom-end" classNames={classes}>
      <Menu.Target>
        <Paper bg="var(--bg-400)" radius={5} py={12} px={16}>
          <Button px={0} variant="transparent" style={{
          pointerEvents: 'auto'
        }}>
            <Image src={service.imgUrl} h={26} alt="token-logo" />
          </Button>
        </Paper>
      </Menu.Target>

      <Menu.Dropdown>
        {services.map(item => <Menu.Item key={item.id} onClick={() => setServices(item)}>
            <Image src={item.imgUrl} h={26} w={100} alt="services-providers" fit="contain" />
          </Menu.Item>)}
      </Menu.Dropdown>
    </Menu>;
};